import { useCallback, useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';

// reducers
import { selectDistribution, resetDistribution } from 'hyc-store/reducers/distribution';

// components
import { ShipmentTile } from './shipment/shipment-tile';
import { ShipmentListTile } from './shipment-list/shipment-list-tile';

const DistributionDashboard = () => {
    const store = useStore();
    const { today } = useSelector(selectDistribution);

    const update = useCallback(() => {
        if (!today) {
            store.dispatch(resetDistribution());
        }
    }, [store, today]);

    const reset = useCallback(() => {
        store.dispatch(resetDistribution());
    }, [store]);

    useEffect(() => {
        update();

        return () => {
            reset();
        }
    }, [update, reset]);

    return (
        <div className="container">

            <nav className="level">
                <div className="level-right">

                    <div className="level-item">
                        <div>
                            <h1 className="title">Distribution Dashboard</h1>
                            <h2 className="heading is-2">From here, you would be able to handle all the distribution tasks!</h2>
                        </div>
                    </div>

                </div>
            </nav>

            <ShipmentTile />
            <ShipmentListTile />

        </div>
    );
}

export { DistributionDashboard };
